export default {
    setPage(state: { page_allowed: Array<any> }, data: Array<any>) {
        state.page_allowed = data;
    }
}
